<template>

    <div>   
        <div class="page-header">
            <h3>{{ $t('users') }}</h3>
            <router-link :to="{name : 'admin.users.create'}" class="btn btn-success">
                <fa :icon="['fal','plus-circle']" /> {{ $t('add_new_user') }}
            </router-link>
        </div>

        <grid 
            :data="users"
            :columns="columns"
            v-on:update-data="fetchData"
            v-on:row-clicked="goToEdit"
            edit-route="/admin/users"
            delete-route="/api/user"
            reset-route="/api/password/email"
            with-edit
            with-delete with-reset></grid>
    </div>
</template>
<script>
import $ from 'jquery'
import axios from "axios";
import Grid from "~/components/Grid";

export default {
    data() {
        return {
            creating: false,
            users: null,
            editUser: 0,
            columns: [
                {'col' : 'name', 'title':'Namn'},
                {'col' : 'email', 'title':'E-mail'},
                {'col' : 'created_at', 'title':'Skapades'},
                {'col' : 'role', 'title':'Roll'},
                {'col' : 'active', 'title':'Aktiv'},
                //{'col' : 'status', 'title':'Status'},
            ]
        };
    },
    components: {
        Grid
    },
    created() {
        this.fetchData();
    },
    methods: {
        userReset(){
            this.editUser = 0;
        },
        goToEdit(entry){
            this.$router.push("/admin/users/" + entry.id)
        },
        async deleteUser(id) {
            if(confirm(this.$t('delete_user'))){
                const { data } = await axios.delete("/api/user/" + id)
                this.users = data;
            }
        },
        async fetchData() {
            this.error = this.users = null;
            this.loading = true;
            
            const { data } = await axios.get("/api/user");

            this.loading = false;
            this.users = data;
        },
    }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/pages/admin/users/index.vue